import { render, staticRenderFns } from "./communicationDashboardSignatureGenerator.vue?vue&type=template&id=47b50d40&scoped=true"
import script from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardSignatureGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardSignatureGenerator.vue?vue&type=style&index=0&id=47b50d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b50d40",
  null
  
)

export default component.exports